import React from 'react';
type SectionHeadingProps = {
  title: string;
  subtitle?: string;
  tone?: 'light' | 'dark';
  align?: 'left' | 'center';
  id?: string;
};
export function SectionHeading({
  title,
  subtitle,
  tone = 'light',
  align = 'center',
  id
}: SectionHeadingProps) {
  const dark = tone === 'dark';
  return <div className={align === 'center' ? 'mx-auto max-w-3xl text-center' : 'max-w-2xl'} data-id="element-255" data-mp="3jzdl8fudhe9s">
      <h2 id={id} className={`font-display text-[28px] font-bold leading-tight md:text-4xl ${dark ? 'text-white' : 'text-ink'}`} data-id="element-256" data-mp="bjtw9t0qii0j">
        {title}
      </h2>
      {subtitle && <p className={`mt-4 text-lg leading-relaxed ${dark ? 'text-navy-soft' : 'text-body'}`} data-id="element-257" data-mp="glawdmbea0g2">{subtitle}</p>}
    </div>;
}